import Constants from '@/Constants';
import { Answer } from '@/models/Question';
import { ApplicationState } from '@/store';
import { getQuestionRequest } from '@/store/questionnaire/action';
import React from 'react';
import { useDispatch,useSelector } from 'react-redux';
import './style.scss';

interface PropsType {
    answerIndex: number;
    setAnswerIndex: (index: number) => void;
    show: boolean;
    setShow: (value: boolean) => void;
}

const NavigateQuestionModal = ({ show, setShow, answerIndex, setAnswerIndex }: PropsType) => {
    const { strings, questionnaire } = useSelector((state: ApplicationState) => {
        return { strings: state.locale.data, questionnaire: state.questionnaire.questionnnaire };
    });

    const qtyColumns = (): string => {
        if (questionnaire.answers.length < 7) return questionnaire.answers.map(() => '1fr').join(' ');
        return 'repeat(7, 1fr)';
    };

    const handleCloseClick = () => {
        setShow(false);
    };

    const dispatch = useDispatch();

    const handleQuestionClick = (answer: Answer, index: number): void => {
        setShow(false);
        setAnswerIndex(index);
        index !== answerIndex && dispatch(getQuestionRequest(questionnaire.id, answer.question.id));
    };

    return (
        <>
            {show && (
                <div className="navigate-question-modal">
                    <div className="navigate-question-modal__wrapper">
                        <div className="navigate-question-modal__container">
                            <i className="material-icons" onClick={handleCloseClick}>
                                {Constants.icons.CLOSE}
                            </i>
                            <div className="title mb-1">
                                {strings.QUESTION} {answerIndex}
                            </div>
                            <div className="description-nav">{strings.QUESTION_NAVIGATION_CLICK}</div>
                            <div className="description-nav mb-4">{strings.ANSWERED_QUESTION_HIGHLIGHTED}</div>
                            <div
                                className="items"
                                style={{
                                    gridTemplateColumns: qtyColumns(),
                                }}
                            >
                                {questionnaire.answers.map((item, index) => (
                                    <div
                                        className={`item-question ${item.answerOption ? 'answered' : ''}`}
                                        key={index}
                                        onClick={() => handleQuestionClick(item, index + 1)}
                                    >
                                        {index + 1}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NavigateQuestionModal;
